import {createRule, type Maybe} from '@regle/core';
import {isFilled} from '@regle/rules';
import {useTranslation} from '#imports';
import {validateIban} from './iban.validator';

/**
 * IBAN rule
 *
 * @example
 * ```ts
 *  import { useRegle, iban } from '@malt/forms';
 *
 *  const { r$ } = useRegle(... , {
 *    ibanNumber: {iban}
 *  })
 * ```
 *
 * @see {@link https://en.wikipedia.org/wiki/International_Bank_Account_Number International Bank Account Number}
 * @see {@link https://www.iban.com/calculate-iban IBAN Calculator}
 * @see {@link https://en.wikipedia.org/wiki/ISO_13616 ISO 13616}
 * @see {@link https://en.wikipedia.org/wiki/ISO_13616#Modulo_operation_on_IBAN ISO 13616#Modulo operation on IBAN}
 */
export const iban = createRule({
    type: 'iban',
    validator(value: Maybe<string>) {
        if (isFilled(value)) {
            return validateIban(value);
        }
        return true;
    },
    message: () => {
        const {t} = useTranslation();
        return t('generic.forms.validation.errors.iban');
    },
});
